import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TransferToFirmModal.css';

/**
 * Transfer to Firm Modal
 * Allows attorneyadmin to transfer an application to an external law firm
 */
function TransferToFirmModal({ application, externalFirms, onClose, onTransfer, isLoading }) {
  const { t } = useTranslation('attorney');
  const [selectedFirmId, setSelectedFirmId] = useState('');
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedFirmId) return;
    onTransfer(application.id, selectedFirmId, reason || null);
  };

  return (
    <div className="transfer-modal-overlay" onClick={onClose}>
      <div className="transfer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="transfer-modal-header">
          <h2>{t('attorney.transfer.title', 'Transfer Application')}</h2>
          <button className="transfer-modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="transfer-modal-body">
          <div className="transfer-app-info">
            <div className="transfer-app-id">{application.applicationId}</div>
            <div className="transfer-app-name">{application.trademark?.name || 'Unknown'}</div>
            <div className="transfer-app-client">
              {t('attorney.transfer.client', 'Client')}: {application.clientName}
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="transfer-form-group">
              <label htmlFor="targetFirm">
                {t('attorney.transfer.selectFirm', 'Select External Law Firm')}
              </label>
              <select
                id="targetFirm"
                value={selectedFirmId}
                onChange={(e) => setSelectedFirmId(e.target.value)}
                required
                disabled={isLoading}
              >
                <option value="">
                  {t('attorney.transfer.chooseFirm', '-- Choose a firm --')}
                </option>
                {externalFirms.map((firm) => (
                  <option key={firm.clerkOrgId} value={firm.clerkOrgId}>
                    {firm.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="transfer-form-group">
              <label htmlFor="reason">
                {t('attorney.transfer.reason', 'Reason for Transfer (optional)')}
              </label>
              <textarea
                id="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder={t('attorney.transfer.reasonPlaceholder', 'e.g., Specializes in this jurisdiction...')}
                rows={3}
                disabled={isLoading}
              />
            </div>

            <div className="transfer-warning">
              <span className="warning-icon">⚠️</span>
              <p>
                {t(
                  'attorney.transfer.warning',
                  'This will transfer the application to the selected firm. The current attorney assignment will be cleared.'
                )}
              </p>
            </div>

            <div className="transfer-modal-footer">
              <button
                type="button"
                className="transfer-cancel-btn"
                onClick={onClose}
                disabled={isLoading}
              >
                {t('common.cancel', 'Cancel')}
              </button>
              <button
                type="submit"
                className="transfer-submit-btn"
                disabled={!selectedFirmId || isLoading}
              >
                {isLoading
                  ? t('attorney.transfer.transferring', 'Transferring...')
                  : t('attorney.transfer.confirmTransfer', 'Transfer Application')
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default TransferToFirmModal;
